import { render, staticRenderFns } from "./institutionalMember.vue?vue&type=template&id=4404db64&scoped=true&"
import script from "./institutionalMember.vue?vue&type=script&lang=js&"
export * from "./institutionalMember.vue?vue&type=script&lang=js&"
import style0 from "./institutionalMember.vue?vue&type=style&index=0&id=4404db64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404db64",
  null
  
)

export default component.exports